/**
 * Adds functionality to the account menu
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/events/trigger/trigger.js";

export default obj => {
	obj.on("change", function () {
		$(this).parents("form").trigger("submit");
	});
};
